import { Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { WantedListingsWall } from '../../WantedListings/WantedListingsWall';

const { Title } = Typography;

const SectionWrapper = styled.section`
  background-color: white;
  padding: 60px 20px;

  @media (min-width: 768px) {
    padding: 80px 40px;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled(Title)`
  text-align: center;
  margin-bottom: 40px !important;
  font-size: 32px !important;

  @media (min-width: 768px) {
    font-size: 40px !important;
    margin-bottom: 60px !important;
  }
`;

export const WantedListingsSection: React.FC = () => {
  const { t } = useTranslation('wanted-listings');

  return (
    <SectionWrapper>
      <ContentWrapper>
        <SectionTitle level={2}>{t('HOME_BOARD_TITLE')}</SectionTitle>
        <WantedListingsWall />
      </ContentWrapper>
    </SectionWrapper>
  );
};
